<template>
    <div
        class="focus:outline-none transition duration-150 ease-in-out"
        :class="{ active: openDropdown }"
        @click="openDropdown = true"
        @keydown.esc="closeDropdown()"
        v-on-clickaway="closeDropdown"
        tabindex="0"
    >
        <slot name="dropdown-toggle"></slot>
        <transition
            enter-active-class="transition ease-out duration-100 transform"
            enter-class="opacity-0 md:scale-95 md:scale-y-100 scale-y-0"
            enter-to-class="opacity-100 md:scale-100 scale-y-100"
            leave-active-class="transition ease-in duration-75 transform"
            leave-class="opacity-100 md:scale-100 scale-y-100"
            leave-to-class="opacity-0 md:scale-95 md:scale-y-100 scale-y-0"
        >
            <slot name="dropdown-content" v-if="openDropdown"></slot>
        </transition>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
    data: () => ({
        openDropdown: false,
    }),
    methods: {
        closeDropdown() {
            const body = document.body;
            this.openDropdown = false;
            body.classList.remove('overflow-hidden');
        },
        toggleDropdown() {
            const body = document.body;
            this.openDropdown = !this.openDropdown;
            if (this.openDropdown) {
                body.classList.add('overflow-hidden');
            } else {
                body.classList.remove('overflow-hidden');
            }
        },
    },
    mixins: [clickaway],
};
</script>

<style scoped>
.active > span {
    font-weight: 600;
}
</style>
